module.exports = "/assets/7f2819e97edf3f75d4c77e6bcb4dbece.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/8P.png
// module id = 1143
// module chunks = 0